import _tmpl from "./tag.html";
import { LightningElement, registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import { b as Truncate } from "ax/chunk_button.constants";
class Tag extends LightningElement {
  constructor(...args) {
    super(...args);
    this.ariaLabel = null;
    this.ariaLive = null;
    this.href = null;
    this.disabled = false;
    this.text = null;
    this.target = null;
    this.truncate = Truncate.Default;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Tag, {
  publicProps: {
    ariaLabel: {
      config: 0
    },
    ariaLive: {
      config: 0
    },
    href: {
      config: 0
    },
    disabled: {
      config: 0
    },
    text: {
      config: 0
    },
    target: {
      config: 0
    },
    truncate: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Tag, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;